import BackofficeAdvice from "../../components/backofficeAdvice/advice";

const Backoffice = () => {

    return(
        <>
            <BackofficeAdvice />
        </>
    )
}

export default Backoffice;

